import React, { useState } from 'react';
import { ChevronLeftIcon, ChevronRightIcon } from 'lucide-react';
import { AnimatePresence, motion, useReducedMotion } from 'framer-motion';
type EbookSlide = {
  src: string;
  alt: string;
  label: string;
};
const slides: EbookSlide[] = [{
  src: 'https://cdn.magicpatterns.com/uploads/cAU76ADuTY4j9TvbeAaYkA/10.png',
  alt: 'Ficha visual del punto VB21 Jianjing para tensión en trapecios y estrés cargado',
  label: 'Ficha VB21 · Trapecios'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/a7tUbkopZdRHpFnTsjSiZA/21.png',
  alt: 'Ficha visual del punto IG4 Hegu para dolor de cabeza y migraña',
  label: 'Ficha IG4 · Migraña'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/qhRUSsRbyNzvQNezmxHLpu/25.png',
  alt: 'Ficha visual del punto C7 Shenmen para insomnio y mente inquieta',
  label: 'Ficha C7 · Insomnio'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/vCg41iLvnqTYbNP1W2s4iq/36.png',
  alt: 'Ficha visual del punto E21 Liangmen para acidez, reflujo y ardor estomacal',
  label: 'Ficha E21 · Acidez'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/j2MPY3aCE84Ezt97vKrrJy/47.png',
  alt: 'Ficha visual del punto RM4 Guanyuan para irregularidad del ciclo menstrual',
  label: 'Ficha RM4 · Ciclo'
}, {
  src: 'https://cdn.magicpatterns.com/uploads/37igdGAHxiC17qxdDLgrmV/59.png',
  alt: 'Ficha visual del punto R1 Yongquan para relajación profunda y descanso',
  label: 'Ficha R1 · Descanso'
}];
export function EbookCarousel() {
  const [activeIndex, setActiveIndex] = useState(0);
  const [direction, setDirection] = useState(1);
  const reduceMotion = useReducedMotion();
  const activeSlide = slides[activeIndex];
  const navigate = (nextIndex: number, nextDirection: number) => {
    setDirection(nextDirection);
    setActiveIndex((nextIndex + slides.length) % slides.length);
  };
  const handleKeyDown = (event: React.KeyboardEvent<HTMLDivElement>) => {
    if (event.key === 'ArrowLeft') {
      event.preventDefault();
      navigate(activeIndex - 1, -1);
    }
    if (event.key === 'ArrowRight') {
      event.preventDefault();
      navigate(activeIndex + 1, 1);
    }
  };
  return <div className="w-full max-w-[290px] justify-self-center focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-4 focus-visible:outline-brand-forest" role="region" aria-roledescription="carrusel" aria-label="Muestra de fichas de El Botiquín Ancestral" tabIndex={0} onKeyDown={handleKeyDown} data-id="element-29" data-mp="2het5sth1jun1">
      <div className="relative isolate aspect-[3/4] overflow-hidden rounded-2xl border border-brand-gold/30 bg-brand-surfaceLight/55 shadow-[0_18px_36px_rgba(34,54,70,0.16)] focus-within:ring-2 focus-within:ring-brand-forest focus-within:ring-offset-2 focus-within:ring-offset-brand-paper" data-id="element-30" data-mp="355f1dl9uzmg5">
        <AnimatePresence custom={direction} initial={false} mode="wait" data-id="element-31" data-mp="1oryno37p57cq">
          <motion.img key={activeSlide.src} src={activeSlide.src} alt={activeSlide.alt} className="absolute inset-0 h-full w-full select-none object-contain touch-pan-y" custom={direction} initial={reduceMotion ? false : {
          opacity: 0,
          x: direction * 28
        }} animate={{
          opacity: 1,
          x: 0
        }} exit={reduceMotion ? undefined : {
          opacity: 0,
          x: direction * -28
        }} transition={{
          duration: reduceMotion ? 0 : 0.24,
          ease: [0.25, 1, 0.5, 1]
        }} drag={reduceMotion ? false : 'x'} dragConstraints={{
          left: 0,
          right: 0
        }} dragElastic={0.86} dragTransition={{
          bounceStiffness: 360,
          bounceDamping: 30
        }} onDragEnd={(_, info) => {
          if (info.offset.x < -48 || info.velocity.x < -420) {
            navigate(activeIndex + 1, 1);
          }
          if (info.offset.x > 48 || info.velocity.x > 420) {
            navigate(activeIndex - 1, -1);
          }
        }} draggable={false} decoding="async" data-id="element-32" data-mp="1jr13jl34m38l" />
        </AnimatePresence>

        <button type="button" onClick={() => navigate(activeIndex - 1, -1)} className="absolute left-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-brand-paper/80 bg-brand-ink/85 text-brand-paper shadow-md transition-colors hover:bg-brand-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-forest" aria-label="Ver imagen anterior" data-id="element-33" data-mp="a7im8l130nj7">
          <ChevronLeftIcon className="h-5 w-5" aria-hidden="true" data-id="element-34" data-mp="3inc5v8qpmf4h" />
        </button>
        <button type="button" onClick={() => navigate(activeIndex + 1, 1)} className="absolute right-2 top-1/2 z-10 flex h-10 w-10 -translate-y-1/2 items-center justify-center rounded-full border border-brand-paper/80 bg-brand-ink/85 text-brand-paper shadow-md transition-colors hover:bg-brand-forest focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-forest" aria-label="Ver imagen siguiente" data-id="element-35" data-mp="38k6u6gal87sb">
          <ChevronRightIcon className="h-5 w-5" aria-hidden="true" data-id="element-36" data-mp="4wwdkdqdoqc" />
        </button>

        <p className="absolute bottom-3 left-1/2 z-10 -translate-x-1/2 rounded-full bg-brand-ink/85 px-3 py-1 text-[10px] font-bold uppercase tracking-[0.12em] text-brand-paper shadow-sm" data-id="element-37" data-mp="3hd0fovgmo3em">
          {activeIndex + 1} de {slides.length}
        </p>
      </div>
      <p className="sr-only" aria-live="polite" data-id="element-38" data-mp="2axhj7gxwqkub">
        Mostrando {activeSlide.label}, imagen {activeIndex + 1} de{' '}
        {slides.length}.
      </p>

      <div className="mt-3 flex items-center justify-center gap-1.5" aria-label="Elegir imagen de muestra" data-id="element-39" data-mp="he7hd5xelddf">
        {slides.map((slide, index) => {
        const isActive = index === activeIndex;
        return <button key={slide.src} type="button" onClick={() => navigate(index, index >= activeIndex ? 1 : -1)} className={`h-2.5 rounded-full transition-[width,background-color] duration-200 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-brand-forest ${isActive ? 'w-6 bg-brand-forest' : 'w-2.5 bg-brand-gold/45 hover:bg-brand-gold'}`} aria-label={`Ver ${slide.label}`} aria-current={isActive ? 'true' : undefined} data-id="element-40" data-mp="2qmglio03q8o" data-mpi={index} />;
      })}
      </div>
      <p className="mt-2 text-center text-[11px] font-medium text-brand-muted" data-id="element-41" data-mp="1e4ro2lnfai8r">
        Deslizá o usá las flechas para ver las fichas.
      </p>
    </div>;
}